import React, { ChangeEvent } from 'react'
import { ConsentText } from '@mobi/account/Areas/SignUp/Components/Message/ConsentText'
import { Checkbox } from '@mobi/component-library/Selection&Input/Inputs'

type Props = { isBusy: boolean; onChange: (e: ChangeEvent<HTMLInputElement>) => void }
export const DocumentPermission = ({ isBusy, onChange }: Props) => {
  return (
    <Checkbox
      name='ConsentText'
      label={<ConsentText />}
      isDisabled={isBusy}
      onChange={e => onChange(e)}
    />
  )
}
